import { getLogger } from '@deltachat-desktop/shared/logger'

const log = getLogger('renderer/utils/getJsonFromBase64')

/**
 * Decode a base64 payload (e.g. `BackendRemote.rpc.getHttpResponse(...).blob`)
 * as UTF-8 JSON. Returns `null` when it can't be decoded or parsed.
 */
export const getJsonFromBase64 = (base64: string): any => {
  try {
    const text = atob(base64)
    const length = text.length
    const bytes = new Uint8Array(length)
    for (let i = 0; i < length; i++) {
      bytes[i] = text.charCodeAt(i)
    }
    const decoder = new TextDecoder()
    return JSON.parse(decoder.decode(bytes))
  } catch (_error) {
    log.critical('String could not de decoded or parsed')
    return null
  }
}
